<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid">
    <div v-for="(shift, index) in shiftData" class="row mb-3">
      <container-expand-right v-bind:title="shift.SiteShiftName" @expanded="index == 0">
        <div class="col-12 px-2" v-for="(locationShift, index2) in shift.LocationShifts">
          <div class="col-12 px-2 mt-1 font-size-md"><b>{{locationShift.LocationName}} <nobr>({{locationShift.StartTime}} - {{locationShift.EndTime}})</nobr></b></div>
          <div class="col-12 px-2 mt-1" v-for="(user, index3) in locationShift.Users">

            <div class="media">
              <div class="mr-1">
                <user-detail-button v-bind:username="user.Username" v-bind:url="'/api/membership/GetSquareImage?username=' + user.Username" v-bind:size="36"></user-detail-button>
              </div>
              <div class="media-body pt-1" v-if="user.FullName != null">
                {{user.FullName}}
              </div>
              <div class="media-body pt-1" v-if="user.FullName == null">
                {{user.Username}}
              </div>
            </div>

          </div>
        </div>
      </container-expand-right>
    </div>

  </div>
</template>

<script>

  import containerExpandRight from '../containers/container-expand-right.vue'
  import moment from 'moment'

  export default {
    name: "shift-personel",

    components: {
      containerExpandRight
    },
    props: {
      date: {
        required: false,
        type: Date,
        default: null,
      },
    },
    data() {
      return {
        yesterday:null,
        dateString:"",
        tomorrow: null,
        shiftData: []
      };
    },
    methods: {
      loadShifts(date) {

        var momentDate = moment(date);
        this.date = date;
        this.dateString = momentDate.format('ddd') + ' ' + momentDate.format('YYYY-MM-DD')
        this.tomorrow = moment(date).add(1, 'day').toDate();
        this.yesterday = moment(date).subtract(1, 'day').toDate();

        try {
          var url = '/api/Admin/v1/Users/Schedule?date=' + momentDate.format('YYYY-MM-DD') + '&day=' + momentDate.day();
          this.$http.get(url).then(async response => {
            this.shiftData = response.data;
          });
        }
        catch (err) {
        }
      },
      
      getId() {
        return this._uid;
      },
     
    },
    watch: {
      date: function (newVal, oldVal) {
        this.loadShifts(newVal);
      },
    },
    mounted() {
      if (this.date == null) {
        this.date = new Date();
      }
      this.loadShifts(this.date);
    }
  };
</script>

<style scoped>



  .select_container {
    width: calc(100%)
  }

  .custom-table-text {
    font-size: 14px;
    height:40px;
  }

  @media screen and (max-width:768px) {
    .custom-table-text {
      font-size: 10px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/shift/shift-personel.vue